module.exports = __webpack_public_path__ + "static/media/welcome-tshirt.8ec066ce.svg";